// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"LoadingSpinner-module--loadingSpinner--1pcDJ","loadingspin":"LoadingSpinner-module--loadingspin--1qsbQ"};